import { Link } from '../../atoms/link/Link';
import { Text } from '../../typography/text/Text';
import styles from './IconBox.module.scss';
import MediaImage from '@frontastic/catwalk/src/js/mediaImage';
import clsx from 'clsx';
import React from 'react';

const IconBox = React.forwardRef(({ title, link, image, isActive = false }, ref) => {
  const hasTitleOnly = title && !image?.media;

  return (
    link && (
      <Link
        className={clsx(styles.root, styles.iconBox, {
          [styles.isActive]: isActive,
          [styles.hasTitleOnly]: hasTitleOnly,
        })}
        link={link}
        title={title}
        ref={ref}
      >
        {image && image?.media && (
          <span className={styles.imageWrapper}>
            <MediaImage className={styles.image} options={{ crop: 'pad', background: 'transparent' }} media={image} />
          </span>
        )}
        {title && (
          <Text as="p" size="xs" weight="light" align="center" textTransform="none" className={styles.iconBoxText}>
            {title}
          </Text>
        )}
      </Link>
    )
  );
});

export default IconBox;
